"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum;
(function (TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum) {
    TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum["Empty"] = "Empty";
    TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum["Add"] = "Add";
    TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum["Remove"] = "Remove";
    TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum["Replace"] = "Replace";
    TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum["Reset"] = "Reset";
})(TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum = exports.TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum || (exports.TableauNlpRefinementuiPhraseMetadataDiscourseTypeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum;
(function (TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum) {
    TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum["Unspecified"] = "PHRASESTATEMODE_UNSPECIFIED";
    TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum["Inplay"] = "PHRASESTATEMODE_INPLAY";
    TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum["Preview"] = "PHRASESTATEMODE_PREVIEW";
    TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum["Phrasebuilder"] = "PHRASESTATEMODE_PHRASEBUILDER";
})(TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum = exports.TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum || (exports.TableauNlpRefinementuiPhraseMetadataPhraseStateModeEnum = {})); /**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum;
(function (TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum) {
    TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum["Unspecified"] = "PHRASESHELFTYPE_UNSPECIFIED";
    TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum["Primary"] = "PHRASESHELFTYPE_PRIMARY";
    TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum["Secondary"] = "PHRASESHELFTYPE_SECONDARY";
})(TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum = exports.TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum || (exports.TableauNlpRefinementuiPhraseMetadataPhraseShelfTypeEnum = {}));
function TableauNlpRefinementuiPhraseMetadataFromJSON(json) {
    return TableauNlpRefinementuiPhraseMetadataFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiPhraseMetadataFromJSON = TableauNlpRefinementuiPhraseMetadataFromJSON;
function TableauNlpRefinementuiPhraseMetadataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': !runtime_1.exists(json, 'index') ? undefined : json['index'],
        'isCoordinator': !runtime_1.exists(json, 'is_coordinator') ? undefined : json['is_coordinator'],
        'discourseType': !runtime_1.exists(json, 'discourse_type') ? undefined : json['discourse_type'],
        'phraseStateMode': !runtime_1.exists(json, 'phrase_state_mode') ? undefined : json['phrase_state_mode'],
        'phraseShelfType': !runtime_1.exists(json, 'phrase_shelf_type') ? undefined : json['phrase_shelf_type'],
        'mappedTokenIndices': !runtime_1.exists(json, 'mapped_token_indices') ? undefined : json['mapped_token_indices'],
        'isNewPreview': !runtime_1.exists(json, 'is_new_preview') ? undefined : json['is_new_preview'],
    };
}
exports.TableauNlpRefinementuiPhraseMetadataFromJSONTyped = TableauNlpRefinementuiPhraseMetadataFromJSONTyped;
function TableauNlpRefinementuiPhraseMetadataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'is_coordinator': value.isCoordinator,
        'discourse_type': value.discourseType,
        'phrase_state_mode': value.phraseStateMode,
        'phrase_shelf_type': value.phraseShelfType,
        'mapped_token_indices': value.mappedTokenIndices,
        'is_new_preview': value.isNewPreview,
    };
}
exports.TableauNlpRefinementuiPhraseMetadataToJSON = TableauNlpRefinementuiPhraseMetadataToJSON;
